import ElCheckbox from './src/checkbox';

export default ElCheckbox;
